import { valueIsNotNullOrUndefined } from '@afterpay/utils'
import { PaymentMethodType, SelectedPaymentMethod } from '../../../model'

const PAYMENT_METHOD_ID_MAP = {
  [PaymentMethodType.ACH_BANK_ACCOUNT]: 'account',
  [PaymentMethodType.CASH_APP_PAY]: 'cashAppPay',
} as const

export const getPaymentMethodId = (selectedPaymentMethod?: SelectedPaymentMethod): string | undefined => {
  const paymentMethodType = selectedPaymentMethod?.type ?? ''
  const accountOrCashAppPay = PAYMENT_METHOD_ID_MAP[paymentMethodType]

  if (valueIsNotNullOrUndefined(accountOrCashAppPay) && valueIsNotNullOrUndefined(selectedPaymentMethod) && accountOrCashAppPay in selectedPaymentMethod) {
    return selectedPaymentMethod[accountOrCashAppPay].id.toString()
  }
}
